import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import _ from 'lodash';
import moment from 'moment';
import { Observable, startWith, map } from 'rxjs';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { RootScopeService } from 'src/app/services/root-scope.service';

/** 
* added code to format date in text box- e.g - May-30-2023. .
*/
export const MY_FORMATS = {
  parse: {
    dateInput: 'll',
  },
  display: {
    dateInput: 'MMM-DD-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'll',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-admin-filter',
  templateUrl: './admin-filter.component.html',
  styleUrls: ['./admin-filter.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AdminFilterComponent implements OnInit {

  iconConfig: { iconName: string; iconType: string; };
  separatorKeysCodes: number[] = [ENTER, COMMA];

  filterCurrentBatchAlertForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  maxDate = new Date();
  minDate = this.filterCurrentBatchAlertForm?.value?.start;

  /** Below variables are used for User Form Fileld Mat-Chip*/
  @ViewChild('createdByInput') createdByInput!: ElementRef<HTMLInputElement>;
  createdByValue = new FormControl('');
  allCreatedBy: string[] = [];
  selectedCreatedBy: string[] = [];
  filteredCreatedBy: Observable<string[]>;
  isMaxCreatedBy: boolean = false;

  /** Below variables are used for Description Form Fileld Mat-Chip*/
  @ViewChild('descriptionInput') descriptionInput!: ElementRef<HTMLInputElement>;
  descriptionValue = new FormControl('');
  allDescriptions: string[] = [];
  selectedDescriptions: string[] = [];
  filteredDescription: Observable<string[]>;
  isMaxDescription: boolean = false;

  /** Below variables are used for Title Form Fileld Mat-Chip*/
  @ViewChild('titleInput') titleInput!: ElementRef<HTMLInputElement>;
  titleValue = new FormControl('');
  allTitles: string[] = [];
  selectedTitles: string[] = [];
  filteredTitle: Observable<string[]>;
  isMaxTitle: boolean = false;
  @Output() selectedRow: EventEmitter<any> = new EventEmitter();

  constructor(
    public rootScope: RootScopeService,
    public dialog: MatDialog,
    public batchAlertService: BatchAlertService
  ) {
    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light'
    }

    this.filteredCreatedBy = this.createdByValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterCreatedByList(topic) : this.allCreatedBy.slice())),
    );

    this.filteredTitle = this.titleValue.valueChanges.pipe(
      startWith(null),
      map((title: string | null) => (title ? this.filterTitleList(title) : this.allTitles.slice())),
    );

    this.filteredDescription = this.descriptionValue.valueChanges.pipe(
      startWith(null),
      map((description: string | null) => (description ? this.filterDescriptionList(description) : this.allDescriptions.slice())),
    );
    this.fetchAutoCompleteList();
  }

  ngOnInit(): void {
    this.setFilterFormValue();

    if (this.selectedCreatedBy?.length > 0) {
      this.selectedCreatedBy.forEach(x => {
        if (x) this.filterCreatedByList(x)
      })
    }

    if (this.selectedTitles?.length > 0) {
      this.selectedTitles.forEach(x => {
        if (x) this.filterTitleList(x)
      })
    }

    if (this.selectedDescriptions?.length > 0) {
      this.selectedDescriptions.forEach(x => {
        if (x) this.filterDescriptionList(x)
      })
    }
  }


/** The Apply button created to apply the filter on the current batch data as per selected fornfield from the Filter PopUp */
  apply() {
    let tempFilterData = this.batchAlertService.currentBatchTableDataMap.get(this.batchAlertService.clientId);
    let startDate: any = this.filterCurrentBatchAlertForm?.value?.start;
    let endDate: any = moment(this.filterCurrentBatchAlertForm?.value?.end);
    let filterFormData: any = {
      range: { startDate: this.filterCurrentBatchAlertForm.value.start, endDate: this.filterCurrentBatchAlertForm.value.end },
      selectedCreatedBy: this.selectedCreatedBy,
      selectedTitles: this.selectedTitles,
      selectedDescriptions: this.selectedDescriptions,
    }
    

    if (tempFilterData) {

      if (this.filterCurrentBatchAlertForm && this.filterCurrentBatchAlertForm.value && (this.filterCurrentBatchAlertForm.value.start || this.filterCurrentBatchAlertForm.value.end)) {
        if (this.filterCurrentBatchAlertForm.value?.start && !this.filterCurrentBatchAlertForm.value?.end)
          tempFilterData = tempFilterData?.filter((data: any) => new Date(data?.created) >= new Date(startDate));
        if (this.filterCurrentBatchAlertForm.value.end && !this.filterCurrentBatchAlertForm.value.start)
          tempFilterData = tempFilterData?.filter((data: any) => new Date(data?.created) <= new Date(endDate));
        if (this.filterCurrentBatchAlertForm.value.start && this.filterCurrentBatchAlertForm.value.end)
          tempFilterData = tempFilterData?.filter((data: any) => (new Date(data?.created) >= new Date(startDate)) && (new Date(data?.created) <= new Date(endDate)));
      }

      if (this.selectedCreatedBy && this.selectedCreatedBy?.length > 0) {
        tempFilterData = tempFilterData?.filter(x => this.selectedCreatedBy?.find(v => x?.createdBy?.includes(v)))
      }

      if (this.selectedTitles && this.selectedTitles?.length > 0) {
        tempFilterData = tempFilterData?.filter(x => this.selectedTitles?.find(v => x?.title?.includes(v)))
      }

      if (this.selectedDescriptions && this.selectedDescriptions?.length > 0) {
        tempFilterData = tempFilterData?.filter(x => this.selectedDescriptions?.find(v => x?.description?.includes(v)))
      }

      this.batchAlertService.currentBatchAlertData = new MatTableDataSource(tempFilterData);
      this.batchAlertService.filterCurrentBatchAlertFormData = filterFormData;
      this.batchAlertService.filteronCurrentBatchAlertApplied = true;
      this.batchAlertService.openCurrentBatchFilterDialog = false;
      this.selectedRow.emit({
        row: null
      });
      this.batchAlertService.currentBatchSelectedRow = null;
      this.batchAlertService.deleteBatchAlertMsgSuccess = false;
      this.batchAlertService.deleteBatchAlertMsgFail = false;

    }

  }

/**Below method created to retain the filter formfields value for the filter component*/
  setFilterFormValue() {
    const data = this.batchAlertService.filterCurrentBatchAlertFormData;
    if (data) {
      this.selectedCreatedBy = data?.selectedCreatedBy;
      this.selectedTitles = data?.selectedTitles;
      this.selectedDescriptions = data?.selectedDescriptions;
      this.filterCurrentBatchAlertForm = new FormGroup({
        start: new FormControl<Date | null>(data.range.startDate ? new Date(data.range.startDate) : null),
        end: new FormControl<Date | null>(data.range.endDate ? new Date(data.range.endDate) : null),
      });

    }
  }

/** Clear All method resets the form of the filter component  */
  clearAll() {
    this.filterCurrentBatchAlertForm.reset();

    this.allCreatedBy = [];
    this.selectedCreatedBy = [];
    this.allCreatedBy = [];

    this.allTitles = [];
    this.selectedTitles = [];
    this.allTitles = [];

    this.allDescriptions = [];
    this.selectedDescriptions = [];
    this.allDescriptions = [];
    this.fetchAutoCompleteList();

    this.isMaxCreatedBy = false;
    this.isMaxTitle = false;
    this.isMaxDescription = false;

  }

/** Below method fetch the Created By, titles and Description from the current batch alert Data so that we can show the list in the form fields */
  fetchAutoCompleteList() {
    let data = this.batchAlertService.currentBatchTableDataMap.get(this.batchAlertService.clientId);

    if (data && data.length > 0) {
      this.allCreatedBy = this.filterUniqueRows(data, 'createdBy');
      this.allTitles = this.filterUniqueRows(data, 'title');
      this.allDescriptions = this.filterUniqueRows(data, 'description');

      this.updateCreatedByList();
      this.updatedTitleList();
      this.updateDescriptionList();
    }

  }

  /**Below method created generic to filter current batch alert row data */
  filterUniqueRows(data: any, rowName: string) {

    const uniqueRowData: string[] = [];
    data.filter((item) => {
      if (uniqueRowData.includes(item?.[rowName])) {

      } else {
        uniqueRowData.push(item?.[rowName]);

      }
    });
    return uniqueRowData;

  }
/** Below method check the date selection and its validation  */
  checkDatesSelection() {
    const startDate = this.filterCurrentBatchAlertForm?.get('start')?.value;
    const endDate = this.filterCurrentBatchAlertForm?.get('end')?.value;

    if (startDate == null && endDate == null) {
      return false;
    } else {
      if (startDate == null) {
        return true;
      } else if (endDate == null) {
        return true;
      } else {
        return false;
      }
    }

  }

/** Below method disable the Apply button if the form is dirty or no form field is selected */
  disableApplyButton(): boolean {
    if ((!this.filterCurrentBatchAlertForm?.value?.start &&
      !this.filterCurrentBatchAlertForm?.value?.end &&
      this.selectedCreatedBy?.length == 0 &&
      this.selectedTitles?.length == 0 &&
      this.selectedDescriptions?.length == 0) ||
      (this.filterCurrentBatchAlertForm?.invalid && this.filterCurrentBatchAlertForm?.dirty || this.checkDatesSelection())
    ) {
      return true;
    }
    return false;
  }

  /** Below method assighent the start date of the form to minDate Variable  */
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.filterCurrentBatchAlertForm?.value?.start;
  }

  /** Below method is created to close the filter pop-up */
  closeFilter() {
    this.batchAlertService.openCurrentBatchFilterDialog = false;
  }


  /*********** Below methods are created to handle the User FormField and its manipulation ************** */

  addCreatedBy(event: MatChipInputEvent): void {

    if (this.allCreatedBy?.includes(event?.value)) {
      this.selectedCreatedBy.push(event?.value);
    }
    event?.chipInput!.clear();
    this.createdByValue.setValue(null);

  }


  removeCreatedBy(agent: string): void {
    const index = this.selectedCreatedBy.indexOf(agent);
    
    if (index >= 0) {
      this.selectedCreatedBy.splice(index, 1);
      this.allCreatedBy.push(agent);
      this.updateCreatedByList()
      this.isMaxCreatedBy = false;
      this.createdByInput.nativeElement.value = '';
      this.createdByValue.setValue(null);
    }
  }

  selectedCreatedBys(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedCreatedBy.length < 3) {
      this.selectedCreatedBy.push(event?.option.viewValue);
      this.isMaxCreatedBy = false;
    }
    else {
      this.isMaxCreatedBy = true;
    }
    this.createdByInput.nativeElement.value = '';
    this.createdByValue.setValue(null);
  }

  filterCreatedByList(value: string): string[] {
    const filterValue = value.toLowerCase();

    if (this.allCreatedBy.find(x => x.toLowerCase() == filterValue) && this.selectedCreatedBy.length < 3)

      return this.allCreatedBy = this.allCreatedBy.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allCreatedBy.filter(agent => agent.toLowerCase().includes(filterValue));
  }

  updateCreatedByList() {
    this.filteredCreatedBy = this.createdByValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterCreatedByList(topic) : this.allCreatedBy.slice())),
    );
  }




  /*********** Below methods are created to handle the Title FormField and its manipulation ************** */



  addTitle(event: MatChipInputEvent): void {

    if (this.allTitles?.includes(event?.value)) {
      this.selectedTitles.push(event?.value);
    }
    event?.chipInput!.clear();
    this.titleValue.setValue(null);

  }


  removeTitle(title: string): void {
    const index = this.selectedTitles.indexOf(title);

    if (index >= 0) {
      this.selectedTitles.splice(index, 1);
      this.allTitles.push(title);
      this.updatedTitleList();
      this.isMaxTitle = false;
      this.titleInput.nativeElement.value = '';
      this.titleValue.setValue(null);
    }
  }

  selectedTitle(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedTitles.length < 3) {
      this.selectedTitles.push(event?.option.viewValue);
      this.isMaxTitle = false;
    }
    else {
      this.isMaxTitle = true;
    }
    this.titleInput.nativeElement.value = '';
    this.titleValue.setValue(null);
  }

  filterTitleList(value: string): string[] {
    const filterValue = value.toLowerCase();

    if (this.allTitles.find(x => x.toLowerCase() == filterValue) && this.selectedTitles.length < 3)

      return this.allTitles = this.allTitles.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allTitles.filter(title => title.toLowerCase().includes(filterValue));
  }

  updatedTitleList() {
    this.filteredTitle = this.titleValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterTitleList(topic) : this.allTitles.slice())),
    );
  }



  /*********** Below methods are created to handle the Description FormField and its manipulation ************** */


  addDescription(event: MatChipInputEvent): void {

    if (this.allDescriptions?.includes(event?.value)) {
      this.selectedDescriptions.push(event?.value);
    }
    event?.chipInput!.clear();
    this.descriptionValue.setValue(null);

  }


  removeDescription(description: string): void {
    const index = this.selectedDescriptions.indexOf(description);

    if (index >= 0) {
      this.selectedDescriptions.splice(index, 1);
      this.allDescriptions.push(description);
      this.updateDescriptionList()
      this.isMaxDescription = false;
      this.descriptionInput.nativeElement.value = '';
      this.descriptionValue.setValue(null);
    }
  }

  selectedDescription(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedDescriptions.length < 3) {
      this.selectedDescriptions.push(event?.option.viewValue);
      this.isMaxDescription = false;
    }
    else {
      this.isMaxDescription = true;
    }
    this.descriptionInput.nativeElement.value = '';
    this.descriptionValue.setValue(null);
  }

  filterDescriptionList(value: string): string[] {
    const filterValue = value.toLowerCase();

    if (this.allDescriptions.find(x => x.toLowerCase() == filterValue) && this.selectedDescriptions.length < 3)

      return this.allDescriptions = this.allDescriptions.filter(x => x.toLowerCase() != filterValue)
    else
      return this.allDescriptions.filter(description => description.toLowerCase().includes(filterValue));
  }

  updateDescriptionList() {
    this.filteredDescription = this.descriptionValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterDescriptionList(topic) : this.allDescriptions.slice())),
    );

  }


}
